var showCard = (function (url, success) {
  var $card = $('#card-popup');
  if ($card.length === 0) {
    const tmpl = $('#card-tmpl').text();
    if (!tmpl) {
      throw {
        message: 'Не найден шаблон карточки #card-tmpl'
      };
    }
    $card = $(tmpl).appendTo('#page-wrapper');
  } else {
    $card.find('#card-content').empty();
  }

  $card.show();
  $card.addClass('busy');

  $.ajax({
    url: url,
    contentType: 'application/html; charset=utf-8',
    type: 'GET',
    dataType: 'html'
  })
  .success(function (result) {
    $card.removeClass('busy');
    $card.find('#card-content').html(result);

    $('.form-horizontal .card-body', $card).css('max-height', ($(window).height() - $('nav.navbar.navbar-fixed-top').height() - $('.form-horizontal .card-header').height() - 15));

    if (success) {
      success();
    }
  })
  .error(function (xhr, status) {
    hideCard($card);
    console.error(status);
  });

  return $card;
});

var hideCard = function (map, $card) {
  // Убираем активность маркера
    $('.leaflet-marker-icon.leaflet-clickable.popupopen').removeClass('popupopen');
    $('.leaflet-marker-icon.leaflet-interactive.popupopen').removeClass('popupopen');
  // Убираем активность линии или полигона
    $('path.leaflet-clickable.popupopen').attr('class', 'leaflet-clickable');
    $('path.leaflet-interactive.popupopen').attr('class', 'leaflet-interactive');

  $card ? $card.hide() : $('#card-popup').hide();

  //Удаление трека если закрыто окно формирования трека
  //if (map && $('[js=track-card]').closest('#card-popup').is(":hidden")) {
  //  map.eachLayer(function (layer) {
  //    if (layer.options && (layer.options.isTrack || layer.options.isDirection)) {
  //      map.removeLayer(layer);
  //    }
  //  });
  //}
}
